import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import CommentSection from 'app/components/layouts/Comments/CommentSection';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import { withGlobalData } from 'app/utils/withGlobalData';
import ListMusic from 'app/components/music/ListMusic';
import * as listenApi from 'app/requests/listens';
import Title from 'app/components/layouts/Title';
import { useTranslation } from 'next-i18next';
import { useState, useEffect } from 'react';
import { useRouter } from "next/router";
import { NextSeo } from 'next-seo';
import first from 'lodash/first';
import env from '.env.json';

export default function ListenDetail({ singer }) {
  const router = useRouter();
  const [musics, setMusics] = useState([]);
  const keywordSeo = `luyện nghe tiếng anh qua bài hát, practice listening english, ca sỹ ${singer.name}, ${singer.name}`;
  const { t } = useTranslation();

  useEffect(() => {
    fetchMusics();
  }, [singer]);

  const fetchMusics = async () => {
    const result = await listenApi.getSongs({ direction: 'asc', limit: 0, singer_name: singer.name });
    setMusics(result.data);
  }

  return (
    <section className="box-card-area list-test overflow-hidden" id="songPage">
      <NextSeo
        title={t('song.learn', { title: singer.name })}
        description={singer.history}
        additionalMetaTags={[{
          name: 'keywords',
          content: keywordSeo
        }]}
      />
      <div className="d-flex">
        <div className="box-news-area">
          <div className='content_inner'>
            <Title title={t('song.singer_info', { name: singer.name })} />
            <div className="singer-detail-info my-3">
              <div className="info-main">
                <div className="info-history-cover info-history">
                  <div className='float-left'>
                    <img
                      className="info-image"
                      alt={singer.name}
                      src={`${env.URL_API_FILE}/${singer.image}`}
                    />
                  </div>
                  <span>
                    {first(singer?.translates)[router?.locale]}
                  </span>
                </div>
              </div>
            </div>
            <div className="form-group">
              <hr className='mt-2' style={{ clear: 'both' }} />
              <h5 className='text-info ml-2'>{t('song.sing_song')}
                <span className='badge badge-info px-3 ml-2'>{musics.length}</span>
              </h5>
              <ListMusic musics={musics} pushUrl={() => { }} />
              <CommentSection roomId={`singer-id-${singer?._id}`} />
            </div>
          </div>
        </div>
        <RightContent />
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query }) => {
  try {
    const [singer, translations] = await Promise.all([
      listenApi.infoSinger(query.name, locale),
      serverSideTranslations(locale, ['common']),
    ]);

    if (!singer) return { notFound: true };

    return {
      props: {
        ...translations,
        singer,
      },
    };
  } catch (error) {
    return { notFound: true };
  }
});
